const trim = (value: string | undefined) => value?.trim() ?? ''

export const siteConfig = {
  name: trim(import.meta.env.VITE_SITE_NAME) || 'United Accountants',
  /** The address the site is served from (unitedaccountants.com redirects here): canonicals, sitemap,
      structured data. Set here only, so no environment can point them somewhere else. */
  siteUrl: 'https://www.unitedaccountants.com',
  /** Every "Book a call" on the site. Set here only, so no environment can bring back an old link. */
  bookingUrl: 'https://calendly.com/lev-unitedaccountants/website-meeting',
  // Where nomination pages (src/nominations) POST accept/decline responses. Normally
  // `/api/nomination-response`, our own function. Empty = not wired; see docs/nominations-storage.md.
  nominationWebhookUrl: trim(import.meta.env.VITE_NOMINATION_WEBHOOK_URL),
  authorName: 'United Accountants',
  /** The company in one sentence: the structured data and the top of llms.txt. Keep LinkedIn and
      other profiles saying the same. */
  description:
    'United Accountants is a technology company that invests in accounting firms and grows them with their owners through Justine (formerly UnitedOS) and capital for acquisitions.',
  /** United's platform. The former name stays in the structured data, so search and answer engines
      connect the two. */
  product: { name: 'Justine', formerName: 'UnitedOS' },
  logo: '/og/logo.svg',
  /** The share image (link previews): the home hero's glass and headline, 1200 × 630 JPEG. */
  ogImage: '/og/ua-share.jpg',
  ogImageWidth: 1200,
  ogImageHeight: 630,
  sameAs: ['https://www.linkedin.com/company/uaunitedaccountants'],
  /** The site's email address: the invitation card and the privacy policy. Nomination pages use
      their reviewer's own address instead. */
  email: 'hello@unitedaccountants.com',
  /** The company behind the site: the privacy policy and the structured data. */
  legal: {
    entityName: 'United Accountants, Inc.',
    registeredAddress: '251 E Little Falls Dr, Wilmington, DE 19808',
    office: { street: '860 Broadway, 5th Floor', city: 'New York', region: 'NY', postalCode: '10003', country: 'US' },
    policyUpdated: '5 October 2026',
  },
}
